import { environment } from "src/environments/environment";

export class Constants {
	public navLinkItems = {
		user: {
			person: { displayName: 'MAX JONES', icon: 'person' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
		home: { home: { displayName: 'Home', url: 'home' } },
		planning: {
			alarms: { displayName: 'ALARMS', url: environment.ALARMS },
			allo: { displayName: 'ALLO', url: environment.ALLO },
			companyInfoChange: { displayName: 'company Info Change', url: 'mshell/maintenance/company-info-change' },
			costPlanning: { displayName: 'COST PLANNING', url: environment.COST_PLANNING },
			eboi: { displayName: 'EBOI', url: environment.EBOI },
			exports: { displayName: 'EXPORTS', url: environment.EXPORT },
			forecastAdmin: { displayName: 'Forecast Admin Dashboard (Import/Export dashboard)', url: environment.FORECAST_ADMIN_DASHBOARD },
			fto: { displayName: 'FTOs', url: 'opershell/operations/fto' },
			group1: { displayName: 'GROUP I', url: environment.GROUPI },
			dashboard: { displayName: 'Import/Export', url: 'opershell/operations/dashboard' },
			masterDock: { displayName: 'Master Dock', url: 'mshell/maintenance/master-dock' },
			regionTargets: { displayName: 'Region Targets', url: 'opershell/operations/region-targets' },
			scnc: { displayName: 'SCNC', url: 'opershell/operations/scnc' },
			taskManager: { displayName: 'TASK MANAGER', url: environment.TASK_MANAGER },
			tlmsSend: { displayName: 'TLMS Send', url: environment.TLMS_SEND },
			delayedDispatch: { displayName: 'Delayed Dispatch', url: environment.DD },
			returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload', fga: ['Returns Reload'] },
		},
		operations: {
			aet: { displayName: 'AET', url: environment.AET },
			companyInfo: { displayName: 'company Info', url: 'mshell/maintenance/company-info' },
			lpBilling: { displayName: 'LP Billing', url: 'bshell', fga: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary'] },
			trailerLoadDiagrams: { displayName: 'Trailer Load Diagrams', url: environment.TLD },
			uxmxroutes: { displayName: 'US MX Routes', url: 'opershell/operations/uxmxroutes' },
			wtResolution: { displayName: 'WT Resolution ', url: 'mshell/maintenance/window-times', fga: ['Window Times', 'TLMS Send'] }
		},
		reporting: {
			scheduleDashboard: { displayName: 'Schedule Dashboard', url: environment.SCHEDULE_DASHBOARD },
			reports: { displayName: 'Reports', url: environment.REPORTS },
		},
		maintenance: {
			notificationGroup: { displayName: 'Notification Group', url: 'admin/notification-group' },
			permissionManagement: { displayName: 'Permission Management', url: 'mshell/apm/permission-management/user-management' },
			returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload', fga: ['Returns Reload'] },

		}
	}

	public LIOSMainPortalURL = this.getLiosUrl();
	public LIOS_UAC_Admin = "Admin";  // access code clean up
	public LIOS_UAC_RoutePlanner = "Route Planner";// access code clean up
	public LIOS_UAC_TEMAOps = "TEMA Ops";// access code clean up
	public LIOS_UAC_TASK_MANAGER_ADMIN = "Task Manager Admin";// access code clean up


	constructor() { }

	public getApiBasePath() {
		return environment.apiUrl;
	}

	public getLiosUrl() {
		return environment.liosUrl;
	}
}
